import * as R from 'ramda'
import { normalize } from 'normalizr'

import { setEntities } from 'actions'
import { getSurveySettings } from 'actions/async'
import * as syncActions from 'actions/sync'
import * as api from 'api'
import { users } from 'api/schema'

export const getUsers = () => (dispatch) => {
  return api
    .getUsers()
    .then((response) => {
      const normalizedData = normalize(response.data, users)
      dispatch(
        setEntities(normalizedData.entities, {
          user: normalizedData.result.results,
        })
      )
    })
    .catch((error) => {
      console.error('[ACTION](getUsers) failed to run')
      throw error
    })
}

export const getConnectwiseCredential = (surveyId) => async (dispatch) => {
  try {
    const { data: credential } = await api.getConnectwiseCredential()
    if (!R.isEmpty(credential)) {
      dispatch(syncActions.setConnectwiseAuthenticationSetting(credential, surveyId))
    }
  } catch (error) {
    console.error('[ACTION](getConnectwiseCredential) failed to run')
    throw error
  }
}

export const createOrUpdateConnectwiseAuthentication = (credential, surveyId) => (dispatch) => {
  return api
    .saveOrUpdateConnectwiseCredential(credential)
    .then(() => {
      dispatch(syncActions.setConnectwiseAuthenticationSetting(credential, surveyId))
    })
    .catch((error) => {
      console.error('[ACTION](createOrUpdateConnectwiseAuthentication) failed to run')
      throw error
    })
}

export const createOrUpdateAutotaskAuthentication = (credential, surveyToken) => (dispatch) => {
  return api
    .saveOrUpdateAutotaskCredential(credential)
    .then(() => {
      dispatch(syncActions.setAutotaskAuthenticationSetting(credential, surveyToken))
    })
    .catch((error) => {
      console.error('[ACTION](createOrUpdateAutotaskAuthentication) failed to run')
      throw error
    })
}

export const getAutotaskCredential = (surveyToken) => async (dispatch) => {
  try {
    const { data: credential } = await api.getAutotaskCredential()
    if (!R.isEmpty(credential)) {
      dispatch(syncActions.setAutotaskAuthenticationSetting(credential, surveyToken))
    }
  } catch (error) {
    console.error('[ACTION](getAutotaskCredential) failed to run')
    throw error
  }
}

export const updateSurveySettings = (surveyId, settings) => (dispatch, getState) => {
  return updateSurveyCustomContent(dispatch, getState(), surveyId, settings)
}

const updateConnectwiseAddSatisfactionSettings = (surveySettings, isActive) => {
  const defaultConnectwiseAddSatisfactionSettings = {
    addSatisfaction: {
      text: 'This ticket received a "[[rating]]" rating. Comment: [[feedback_comment]]. Feedback provided by [[feedback_link]].',
      isActive: false,
    },
  }
  const updatedAddSatisfaction = { addSatisfaction: { isActive } }
  const hasIntegrationSettings = R.hasPath(['addSatisfaction', 'text'], surveySettings)

  return hasIntegrationSettings
    ? updatedAddSatisfaction
    : R.mergeDeepRight(defaultConnectwiseAddSatisfactionSettings, updatedAddSatisfaction)
}

export const updateAddSatisfaction = (surveyId, isActive) => (dispatch, getState) => {
  const state = getState()
  const surveySettings = getSurveySettings(state, surveyId)
  const customContent = updateConnectwiseAddSatisfactionSettings(surveySettings, isActive)
  return updateSurveyCustomContent(dispatch, state, surveyId, customContent)
}

const updateSurveyCustomContent = async (dispatch, state, surveyId, customContent) => {
  const currentCustomContent = getSurveySettings(state, surveyId)
  const survey = {
    settings: R.mergeDeepRight(currentCustomContent, customContent),
  }
  return await updateSurveyFromIdAndThrowIfError(surveyId, survey)(dispatch)
}

export const deactivateConnectwiseIntegration = (surveyToken) => async (dispatch) => {
  try {
    await Promise.all([api.deleteConnectwiseCredential(surveyToken), Promise.delay(2000)])
    dispatch(syncActions.removeConnectwiseCredential(surveyToken))
  } catch (error) {
    console.error('[ACTION](updateAddingSatisfaction) failed to run')
    throw error
  }
}

export const deactivateAutotaskIntegration = (surveyToken) => async (dispatch) => {
  try {
    await Promise.all([api.deleteAutotaskCredential(), Promise.delay(2000)])
    dispatch(syncActions.removeAutotaskCredential(surveyToken))
  } catch (error) {
    console.error('[ACTION](deactivateAutotaskIntegration) failed to run')
    throw error
  }
}

export const updateSurveyFromIdAndThrowIfError = (surveyId, settings) => async (dispatch) => {
  try {
    const response = await api.updateSurveyFromIdAndThrowIfError(surveyId, settings)
    dispatch(syncActions.setSurveyFromId(response.data))
    return response.data
  } catch (error) {
    console.error('[ACTION](updateSurveyFromIdAndThrowIfError) failed to run')
    throw error
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/async/admin.js